import { cdnTemplate } from 'cdnPreprocessor';

export default [
  'ErrorHandler',
  function ErrorModalDirective (ErrorHandler) {
    return {
      restrict: 'E',
      templateUrl: cdnTemplate('/error-modal.html'),
      link: (scope) => {
        scope.toggle = false;
        scope.errors = () => ErrorHandler.getErrors();

        // Appear on a new error
        scope.$watch(
          () => ErrorHandler.getErrors().length,
          (newVal, oldVal) => {
            if (newVal > oldVal) scope.toggle = true;
          }
        );

        // Clear errors when closed
        scope.$watch(
          () => scope.toggle,
          (newVal, oldVal) => {
            if (newVal === false && oldVal === true) ErrorHandler.clear();
          }
        );
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/layout-components/error-modal/error-modal.dir.js